import {Card} from '../../game_table/table_objects/stacks/Card';
import {Stack} from '../../game_table/table_objects/stacks/Stack';
import {CommandStrategy} from './pie_menu_commands/base/CommandStarategy';
import {FlipCardsCommandStarategy} from './pie_menu_commands/FlipCardsCommandStarategy';
import {FlipStacksCommandStarategy} from './pie_menu_commands/FlipStacksCommandStarategy';
import {DeleteStacksCommandStarategy} from './pie_menu_commands/DeleteStacksCommandStarategy';
import {DeleteCardsCommandStarategy} from './pie_menu_commands/DeleteCardsCommandStarategy';
import {TakeStackCardsInHandCommandStarategy} from './pie_menu_commands/TakeStackCardsInHandCommandStarategy';
import {LockStacksCommandStarategy} from './pie_menu_commands/LockStacksCommandStarategy';
import {UnlockStacksCommandStarategy} from './pie_menu_commands/UnlockStacksCommandStarategy';
import {DealXCardsToAllCommandStarategy} from './pie_menu_commands/DealXCardsToAllCommandStarategy';
import {ShuffleStacksCommandStarategy} from './pie_menu_commands/ShuffleStacksCommandStarategy';
import {PutCardsOnTableCommandStarategy} from './pie_menu_commands/PutCardsOnTableCommandStarategy';
import {ZoomCardCommandStarategy} from './pie_menu_commands/ZoomCardCommandStarategy';
import {ZoomStackCommandStarategy} from './pie_menu_commands/ZoomStackCommandStarategy';
import {PassCardToPlayerCommandStarategy} from './pie_menu_commands/PassCardToPlayerCommandStarategy';
import {PassStackToPlayerCommandStarategy} from './pie_menu_commands/PassStackToPlayerCommandStarategy';

export class CommandsStrategiesController
{

    static commandsStrategies: CommandStrategy[] = [
        new FlipCardsCommandStarategy(),
        new FlipStacksCommandStarategy(),
        new DeleteStacksCommandStarategy(),
        new DeleteCardsCommandStarategy(),
        new TakeStackCardsInHandCommandStarategy(),
        new LockStacksCommandStarategy(),
        new UnlockStacksCommandStarategy(),
        new DealXCardsToAllCommandStarategy(),
        new ShuffleStacksCommandStarategy(),
        new PutCardsOnTableCommandStarategy(),
        new ZoomCardCommandStarategy(),
        new ZoomStackCommandStarategy(),
        new PassCardToPlayerCommandStarategy(),
        new PassStackToPlayerCommandStarategy()
    ];

    static getStrategies(card: Card | undefined, stack: Stack | undefined) {
        return CommandsStrategiesController.commandsStrategies.filter(strategy => strategy.isApplicable(card, stack));
    }
}
